import React from "react";
import BudgetVsActual from "@/components/BudgetVsActual";
import { TrendingUp } from "lucide-react";

export default function IncomeBudget() {
  return (
    <BudgetVsActual
      endpoint="/finance/income-budget"
      queryKey="income-budget"
      title="Έσοδα — Προϋπολογισμός vs Πραγματικά"
      subtitle="Μηνιαίος προϋπολογισμός εσόδων ανά λογαριασμό και σύγκριση με τα πραγματικά (καθαρά ποσά, ημ/νία παραστατικού)."
      icon={TrendingUp}
      isCost={false}
      versions
    />
  );
}
